import _ from 'lodash';

import { normalizeRenderedSelect } from 'shared/forms/RenderSelect';

export const prepareBillingInfoData = ({ data }) => {
  data = _.omit(data, ['plan_type']);

  return { ...data, billing_city: normalizeRenderedSelect(data.billing_city) };
};
